/**
 * API autenticada con JWT de miembro (javiland_member_token).
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const memberApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 45000,
  headers: {
    'Content-Type': 'application/json'
  }
});

memberApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('javiland_member_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export async function fetchMemberProfile() {
  const { data } = await memberApi.get('/auth/member-me');
  return data;
}

export async function patchMemberProfile(body) {
  const { data } = await memberApi.patch('/auth/member-me', body);
  return data;
}

export async function fetchMemberRecentOrders() {
  const { data } = await memberApi.get('/orders/member-recent');
  return data;
}

export default memberApi;
